import { dateToISO, dateToday } from 'helpers/date';

const validateDate = (operator, dateValue) => {
  if (operator === 'lt') {
    const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    if (dateToISO(dateValue) < dateToISO(today)) {
      return true;
    }
    return false;
  }
};

export { validateDate as default };
